import { PERCENT_METRICS, type AppliedScenarioMetricKey } from "@/types/applied-scenario.types";

// Spec 079 (US1) — a FORMATAÇÃO da régua, em um lugar só.
//
// ⚠️ Os quatro componentes da aba desenham os mesmos números. Enquanto cada um trazia a própria
// cópia de `pct` e da regra de unidade, mudar a precisão ou o glifo do nulo exigia encontrar cinco
// call sites — e o que se vê quando um deles escapa é a mesma medida escrita de dois jeitos a
// centímetros de distância, dentro do mesmo card.

/** Um formatador por módulo, e não um por chamada: a tabela de métricas renderiza ~5 linhas × N linhas. */
const DECIMAL = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 1 });

/** Percentual, ou "—". Nulo é AUSÊNCIA de amostra — jamais `0` (FR-010). */
export function pct(value: number | null): string {
  if (value === null) return "—";
  return `${DECIMAL.format(value)}%`;
}

/** `pp` para as métricas percentuais; unidades para a produção boa. */
export function metricUnit(metric: AppliedScenarioMetricKey): string {
  return PERCENT_METRICS.has(metric) ? "pp" : "un";
}

/** Valor + unidade da métrica, sem sinal. Nulo é ausência de par previsto+realizado, jamais zero. */
export function magnitude(value: number, metric: AppliedScenarioMetricKey): string {
  return `${DECIMAL.format(Math.abs(value))} ${metricUnit(metric)}`;
}

/** "1 testado" / "12 testados" — concordância junto do número que a governa. */
export function testedLabel(n: number): string {
  return `${n} ${n === 1 ? "testado" : "testados"}`;
}

/** "1 compromisso testado" / "12 compromissos testados" — as DUAS palavras concordam. */
export function testedCommitmentsLabel(n: number): string {
  return n === 1 ? "1 compromisso testado" : `${n} compromissos testados`;
}
